
import React from "react";
import autosize from 'autosize';
import { FormattedMessage } from 'react-intl';
import { Collapse  , Grid, Row, Col, Clearfix } from 'react-bootstrap';
export default class InputToggleComponent extends React.Component {

    constructor(props){
        super();

        this.props = props;
        this.state ={
            id:Math.floor((Math.random() * 1000000) + 1),
            className : props.className,
            autoSize:true,
            toggeled :false,
            checked : this.props.isChecked,
            labelName : String(this.props.defaultTranslation) || '',
            labelTranslationUID : String(this.props.translationUID) || '',
            title:props.title,
            color:this.props.color || 'blue', 
            tag: props.tag || '',
            onCheck: function (i, j) {this.props.onCheck(i, j)}.bind(this)
        }
    }

    componentWillReceiveProps(props){
        this.setState({checked : props.isChecked})
    }

    onChange(){
        this.state.onCheck(this.state.tag, this.toggle.checked);
    }

    render(){


        return (
            <div className="toggle-switch show" data-ts-color={ this.state.color }>
                <Row>
                    <Col sm={6} md={2} lg={2}>
                        <label className={"ts-label "+this.props.className}>{this.state.title}</label>
                    </Col>
                    <Col sm={1}>
                        <div className={"pull-right "+this.props.className}>
                            <input ref={(input) => this.toggle = input}  onChange={this.onChange.bind(this)} type="checkbox" checked={this.state.checked} />
                            <label className="ts-helper"></label>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/inputs/input.toggle.component.js